<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	//Helpers
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Design system components
	import { Container, Radio, Text } from '@Shelly/shelly-design-system';
	//Svelte hooks
	import { beforeUpdate } from 'svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Types
	import type { InputOutputOptions } from './input_output_types';

	export let typeValue: string, modeValue: string, buttonModeOptions: InputOutputOptions;
	// typeValue - relay will be button or switch
	// modeValue - the action of the switch/ button

	const setButtonMode = async (_modeValue) => {
		modeValue = _modeValue;
	};

	let disabled = {};

	beforeUpdate(() => {
		//this lifecycle is going to evaluated every time when typeValue is changed
		//this "disabled" object is changed with new values for every type option
		Array.isArray(Object?.entries(buttonModeOptions))
			? Object?.entries(buttonModeOptions)?.map((option, i) => {
					disabled[i] = option?.[1]?.type !== typeValue && option?.[1]?.type !== 'any';
				})
			: undefined;

		let selectedTypeIndex = Object.keys(buttonModeOptions).indexOf(modeValue);
		//selectedTypeIndex is the index of the previous selected type option
		let isSelectedTypedDisabled = disabled[selectedTypeIndex];
		//isSelectedTypedDisabled checks if the previous selected index is enabled or disabled
		//if is false, then this means that is valid option for the button/switch
		// if not, we have to find and select first available option

		let availableIndexes = [];
		let firstAvailableOption;

		if (isSelectedTypedDisabled) {
			Object.entries(disabled).forEach(([key, value]) => {
				if (!value) {
					//record all available indexes
					availableIndexes.push(key);
				}
			});
			// buttonModeOptions are all relay type options represent in object with keys, keys represent the types
			// availableIndexes[0] returns first available index(0, 1, or 2 and so on)
			// Object.keys(buttonModeOptions)[availableIndexes[0]] select first available type
			firstAvailableOption = Object.keys(buttonModeOptions)[availableIndexes[0]];
			setButtonMode(firstAvailableOption);
		}
	});
</script>

<Container type="base" class="mb-s" padding="xs">
	<Text class="text-bold mb-s">
		{formatSnakeCaseToTitle($format('btn_mode_label'))}
	</Text>
	{#each Object.entries(buttonModeOptions) as option, i}
		<Radio
			size="m"
			bind:selected={modeValue}
			value={option[0]}
			class="mb-s"
			disabled={disabled[i]}
			on:click={() => setButtonMode(option[0])}
			id="radio-kq210o8"
			info={$showNewLayout ? option[1]?.description : undefined}
		>
			{$showNewLayout ? option[1]?.title : option[1]?.text}
		</Radio>
	{/each}
</Container>
